module.exports = __webpack_public_path__ + "img/retaining-wall-5.36b89503.jpeg";